export default "__VITE_ASSET__BL$W6HTl__"